import React, { useState, useEffect } from "react";
import { colors } from "../../../../themes/Colors";
import {
  BaseButtons,
  CheckInput,
  TabButtonFlatButton,
  TextInputField,
  TextInputFieldArea,
} from "../../../common-components";
import SearchBar from "../../../common-components/search-bar/SearchBar";
import {
  BuzzCardNewShape,
  BuzzPostPopUp,
  CreatePostModal,
  RequestCard,
} from "./components";
import BuzzCard from "./components/buzz-card copy/BuzzCard";
import BuzzListItem from "./components/buzz-list-item/BuzzListItem";

const BuzzFeedControlDisplay = ({
  width,
  height,
  setToastPop,
  setMessage,
  setLoading,
  loading,
  setPopUpTitle,
  auth,
}) => {
  const [open, setOpen] = useState(false);
  const [tableDisplay, setTableDisplay] = useState("live");
  const [search, setSearch] = useState("");
  const [createPostModal, setCreatePostModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  const [liveFeed, setLiveFeed] = useState(null);
  const [requestFeed, setRequestsFeed] = useState(null);
  const [originalRequestFeed, setOriginalRequestsFeed] = useState([]);

  const [historyFeed, setHistoryFeed] = useState(null);
  const [originalHistoryFeed, setOriginalHistoryFeed] = useState([]);
  const [declinedFeed, setDeclinedFeed] = useState(null);

  const [filterPopUp, setFilterPopUp] = useState(false);
  const [mainfilterChoice, setMainfilterChoice] = useState("all");

  const [searchText, setSearchtext] = useState("");

  const [selectedPost, setSelectedPost] = useState(null);

  const [ec, setEc] = useState(false);
  const [fs, setFs] = useState(false);
  const [gp, setGp] = useState(false);
  const [kn, setKn] = useState(false);
  const [lp, setLp] = useState(false);
  const [mp, setMp] = useState(false);
  const [nc, setNc] = useState(false);
  const [nw, setNw] = useState(false);
  const [wc, setWc] = useState(false);

  const checkLayout = () => {
    let liveFeedDateSort = liveFeed.sort(
      (a, b) =>
        new Date(...a.editedOn.split("/").reverse()) -
        new Date(...b.editedOn.split("/").reverse())
    );
    liveFeedDateSort = liveFeedDateSort.reverse();
    return liveFeedDateSort;
  };

  const checkLayoutHistory = () => {
    let liveFeedDateSort = historyFeed.sort(
      (a, b) =>
        new Date(...a.editedOn.split("/").reverse()) -
        new Date(...b.editedOn.split("/").reverse())
    );
    liveFeedDateSort = liveFeedDateSort.reverse();
    return liveFeedDateSort;
  };

  const postTypeSplit = (postType) => {
    const splitArray = postType.split(",");

    return splitArray;
  };

  const tagsSplit = (tags) => {
    const splitArray = tags.split(",");

    return splitArray;
  };

  const getLiveFeed = () => {
    setLoading(true);
    fetch(process.env.REACT_APP_BACKEND_URL + "/buzzPost/getTodaysFeed")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setLiveFeed(resData.todaysPosts);

        setLoading(false);
      });
  };
  const getRequestsFeed = () => {
    fetch(process.env.REACT_APP_BACKEND_URL + "/buzzPost/getRequestFeed")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setRequestsFeed(resData.requests);
        setOriginalRequestsFeed(resData.requests);
      });
  };
  const getHistoricalFeed = () => {
    fetch(process.env.REACT_APP_BACKEND_URL + "/buzzPost/getPostHistory")
      .then((response) => {
        return response.json();
      })
      .then((resData) => {
        setHistoryFeed(resData.history);
        setOriginalHistoryFeed(resData.history);
      });
  };

  useEffect(() => {
    getLiveFeed();
    getRequestsFeed();
    getHistoricalFeed();
  }, [refresh]);
  useEffect(() => {
    setOpen(true);
  }, []);
  return (
    <div
      style={{
        height: open ? "100%" : 0,
        width: "100%",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "top",
        transition: "all 0.8s",
        backgroundColor: open ? colors.secondaryGrey : colors.primaryBlue,
        flexDirection: "column",
      }}
    >
      {/* tabs */}
      <div
        style={{
          display: "flex",
          height: 40,
          backgroundColor: colors.greenDark,
          top: -40,
          position: "absolute",
        }}
      >
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"LIVE FEED"}
            backgroundColor={
              tableDisplay === "live" ? colors.secondaryGrey : colors.greenLight
            }
            textColor={
              tableDisplay === "live" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("live")}
          />
        </div>
        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"REQUESTS"}
            backgroundColor={
              tableDisplay === "requests"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "requests" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("requests")}
          />
        </div>

        <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"HISTORY"}
            backgroundColor={
              tableDisplay === "history"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "history" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("history")}
          />
        </div>
        {/* <div style={{ marginLeft: 5 }}>
          <TabButtonFlatButton
            title={"DECLINED POSTS"}
            backgroundColor={
              tableDisplay === "declined"
                ? colors.secondaryGrey
                : colors.greenLight
            }
            textColor={
              tableDisplay === "declined" ? colors.greenDark : colors.white
            }
            onClick={() => setTableDisplay("declined")}
          />
        </div> */}
      </div>
      {/* header buttns selectors */}
      <div
        style={{
          width: "100%",
          //   borderStyle: "solid",
          //   borderWidth: 1,
          minHeight: 60,
          display: "flex",
          alignItems: "center",
          //   backgroundColor: colors.white,
          position: "relative",
          zIndex: 200,
        }}
      >
        <div
          style={{
            backgroundColor: colors.white,
            borderRadius: 4,
            display: "flex",
            marginLeft: 10,
          }}
        >
          <TextInputField
            mini={true}
            marginTop={-5}
            // invert={true}
            placeholder={"type here to search"}
            height={20}
            value={searchText}
            onChange={(e) => setSearchtext(e.target.value)}
          />
        </div>
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"CLEAR"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          onClick={() => {
            setSearchtext("");
            setSearch("");
          }}
        />{" "}
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"SEARCH"}
          borderRadius={8}
          backgroundColor={colors.greenLight}
          onClick={() => setSearch(searchText)}
        />
        <div style={{ marginLeft: 10, position: "relative" }}>
          <BaseButtons
            label={"FILTER"}
            borderRadius={8}
            backgroundColor={colors.greenLight}
            onClick={() => setFilterPopUp(filterPopUp ? false : true)}
          />
          {filterPopUp ? (
            <div
              style={{
                position: "absolute",
                backgroundColor: colors.white,
                padding: 10,
                borderRadius: 4,
                bottom: -325,
                minHeight: 300,
                width: 300,
                left: 10,
                WebkitBoxShadow: "0px 0px 7px 2px #00000030",
              }}
            >
              <div
                style={{ marginTop: 10, marginLeft: 10, fontWeight: "bold" }}
              >
                FILTER OPTIONS
              </div>
              <div
                style={{
                  marginTop: 4,
                  marginLeft: 10,
                  fontWeight: "bold",
                  fontSize: 12,
                  opacity: 0.7,
                }}
              >
                please select the options you would like to be able to view
              </div>
              <CheckInput
                label={"ALL"}
                onClick={() => setMainfilterChoice("all")}
                selected={mainfilterChoice === "all" ? true : false}
              />
              <CheckInput
                label={"PROVINCES"}
                onClick={() => setMainfilterChoice("province")}
                selected={mainfilterChoice === "province" ? true : false}
              />
              <CheckInput
                label={"VEHICLE MAKE"}
                onClick={() => setMainfilterChoice("make")}
                selected={mainfilterChoice === "make" ? true : false}
              />
              <CheckInput
                label={"CUSTOME REQUEST"}
                onClick={() => setMainfilterChoice("custom")}
                selected={mainfilterChoice === "custom" ? true : false}
              />

              {mainfilterChoice === "all" ? (
                <div
                  style={{
                    marginTop: 60,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  {" "}
                  "No extra options currently availible"
                </div>
              ) : null}
              {mainfilterChoice === "province" ? (
                <div
                  style={{
                    marginTop: 10,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <div style={{ marginBottom: 4, fontSize: 12 }}>
                    List of provinces
                  </div>
                  <div style={{ display: "flex" }}>
                    <CheckInput
                      label={"EC"}
                      onClick={() => setEc(ec ? false : true)}
                      selected={ec}
                    />
                    <CheckInput
                      label={"FS"}
                      onClick={() => setFs(fs ? false : true)}
                      selected={fs}
                    />
                    <CheckInput
                      label={"GP"}
                      onClick={() => setGp(gp ? false : true)}
                      selected={gp}
                    />
                  </div>
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <CheckInput
                      label={"KN"}
                      onClick={() => setKn(ec ? false : true)}
                      selected={kn}
                    />
                    <CheckInput
                      label={"LP"}
                      onClick={() => setLp(fs ? false : true)}
                      selected={lp}
                    />
                    <CheckInput
                      label={"MP"}
                      onClick={() => setMp(mp ? false : true)}
                      selected={mp}
                    />
                  </div>
                  <div style={{ display: "flex", marginTop: 10 }}>
                    <CheckInput
                      label={"NC"}
                      onClick={() => setNc(ec ? false : true)}
                      selected={nc}
                    />
                    <CheckInput
                      label={"NW"}
                      onClick={() => setNw(fs ? false : true)}
                      selected={nw}
                    />
                    <CheckInput
                      label={"WC"}
                      onClick={() => setWc(gp ? false : true)}
                      selected={wc}
                    />
                  </div>
                </div>
              ) : null}
              {mainfilterChoice === "make" ? (
                <div
                  style={{
                    marginTop: 40,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <TextInputField mini={true} labelTitle={"Vehicle Make"} />
                </div>
              ) : null}
              {mainfilterChoice === "custom" ? (
                <div
                  style={{
                    marginTop: 10,
                    fontWeight: "bold",
                    width: "100%",
                    textAlign: "center",
                  }}
                >
                  <TextInputFieldArea
                    height={80}
                    size={"80%"}
                    mini={true}
                    labelTitle={"Custome search"}
                  />
                </div>
              ) : null}
            </div>
          ) : null}
        </div>
        <div style={{ flex: 1 }} />
        <BaseButtons
          label={"REFRESH"}
          borderRadius={8}
          backgroundColor={colors.orangeDark}
          onClick={() => setRefresh(refresh ? false : true)}
        />
        <div style={{ minWidth: 10 }} />
        <BaseButtons
          label={"+ ADD NEW POST"}
          borderRadius={8}
          backgroundColor={colors.greenLight}
          width={155}
          onClick={() => setCreatePostModal(true)}
        />
        <div style={{ minWidth: 10 }} />
      </div>
      {/* buzz header list view */}
      <div
        style={{
          width: "100%",
          minHeight: 40,
          backgroundColor: colors.greenDark,
          display: "flex",
          alignItems: "center",
        }}
      >
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          <div style={{ marginLeft: 10 }}> SENT TO</div>
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          TITLE (CATEGORY)
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          DESCRIPTION
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.2,
          }}
        >
          SENT BY
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.15,
          }}
        >
          DATE REQUESTED
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.1,
            // display: "flex",
            // justifyContent: "center",
            // alignItems: "center",
          }}
        >
          STATUS
        </div>
        <div
          style={{
            fontWeight: "bold",
            fontSize: 10,
            color: colors.white,
            flex: 0.15,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          ACTIONS
        </div>
      </div>
      {/* table displays */}
      {tableDisplay === "live" ? (
        <div
          style={{
            flex: 1,
            marginTop: 0,
            width: "100%",
            flexWrap: "wrap",
            justifyContent: "center",
            display: "flex",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {liveFeed
            ? checkLayout().map((item, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <BuzzListItem
                      category={item.postToo[0]}
                      subCategory={item.postType[0]}
                      onViewClick={() => setSelectedPost(item)}
                      description={item.shortDescription}
                      sentBy={item.senderDetails}
                      dateRequested={item.dateCreated}
                      status={item.status}
                    />
                  </div>
                );
              })
            : null}
        </div>
      ) : null}
      {tableDisplay === "requests" ? (
        <div
          style={{
            flex: 1,
            // marginTop: 10,
            width: "100%",
            // flexWrap: "wrap",
            justifyContent: "flex-start",
            display: "flex",
            overflowY: "auto",
            overflowX: "hidden",
            flexDirection: "column",
          }}
        >
          {requestFeed
            ? requestFeed.map((item, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <BuzzListItem
                      category={item.postToo[0]}
                      subCategory={item.postType[0]}
                      onViewClick={() => setSelectedPost(item)}
                      description={item.shortDescription}
                      sentBy={item.senderDetails}
                      dateRequested={item.dateCreated}
                      status={item.status}
                      type={tableDisplay}
                    />
                  </div>
                );
              })
            : null}
        </div>
      ) : null}
      {tableDisplay === "history" ? (
        <div
          style={{
            flex: 1,
            // marginTop: 10,
            width: "100%",
            flexWrap: "wrap",
            justifyContent: "center",
            display: "flex",
            overflowY: "auto",
            overflowX: "hidden",
          }}
        >
          {historyFeed
            ? checkLayoutHistory().map((item, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <BuzzListItem
                      category={item.postToo[0]}
                      subCategory={item.postType[0]}
                      onViewClick={() => setSelectedPost(item)}
                      description={item.shortDescription}
                      sentBy={item.senderDetails}
                      dateRequested={item.dateCreated}
                      status={item.status}
                    />

                    {/* <BuzzCardNewShape
                      option2={true}
                      buzzTitle={post.title}
                      senderTitle={post.senderDetails}
                      quickDescription={post.shortDescription}
                      longDescription={post.longDescription}
                      postType={postTypeSplit(post.postType[0])[0]}
                      sourceLink={post.sourceLink}
                      tagsData={tagsSplit(post.tags[0])}
                      postId={post.postId}
                    /> */}
                  </div>
                );
              })
            : null}
        </div>
      ) : null}
      {selectedPost ? (
        <BuzzPostPopUp
          selectedPost={selectedPost}
          setClose={setSelectedPost}
          setLoading={setLoading}
          setMessage={setMessage}
          setPopUpTitle={setPopUpTitle}
          setToastPop={setToastPop}
          setRefresh={setRefresh}
          refresh={refresh}
          type={tableDisplay}
        />
      ) : null}
      <CreatePostModal
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setLoading={setLoading}
        setToastPop={setToastPop}
        refresh={refresh}
        setRefresh={setRefresh}
        display={createPostModal}
        setCreatePostModal={setCreatePostModal}
        auth={auth}
      />
    </div>
  );
};

export default BuzzFeedControlDisplay;
